import {Component, Inject, OnDestroy} from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogModule } from "@angular/material/dialog";
import {IomModuleService} from "../../services/iom-module.service";
import {Subject, take} from "rxjs";
import { MatIconModule } from '@angular/material/icon';

@Component({
    selector: 'app-clear-iom-dialog',
    templateUrl: './clear-iom-dialog.component.html',
    styleUrls: ['./clear-iom-dialog.component.scss'],
    standalone: true,
    imports: [MatDialogModule, MatIconModule]
})
export class ClearIomDialogComponent implements OnDestroy {

  private destroy$ = new Subject<void>();

  constructor(
    private readonly iom: IomModuleService,
    @Inject(MAT_DIALOG_DATA) private data: any) {
  }

  clearIom() {
    this.iom.clearIom$(this.data.iomId)
      .pipe(take(1))
      .subscribe(() => window.location.reload());
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
